import { Route } from 'types/route.type';
import FeedCatalog from './feed-catalog';

export const routes: Route[] = [
  {
    path: '/self-service/feed-catalog/',
    component: FeedCatalog,
    id: 'selfService.feedCatalog.title',
  },
];
